import React from "react";
import { Container, Row, Col } from "reactstrap";
import classnames from "classnames";

import { Link } from "react-router-dom";

// images
import authImage from "../assets/images/auth-img.png";
import config from "../config";
import { Utils } from "helpers/utils";

interface NonAuthLayoutWrapperProps {
  children: any;
  lightBg?: boolean; // opt-in per page: light gray background + accent-colored text on the left/logo panel, instead of the default primary-colored background + white text
}

const SHOW_AUTH_IMG = false; // toggle back to true to bring the illustration back




const NonAuthLayoutWrapper = (props: NonAuthLayoutWrapperProps) => {
  const getLineLoginUrl = () => {
    const isLogin = true;
    const user_type_val = '';
    const channelId = config.LINE.CHANNEL_ID;
    const callbackUrl = config.LINE.CALLBACK;
    const state = (isLogin ? "login_" : "register_") + user_type_val;
    const lineLoginUrl = `https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=${channelId}&redirect_uri=${callbackUrl}&state=${state}&scope=openid%20profile`;
    return lineLoginUrl;
    // window.location.href = lineLoginUrl; // redirect to LINE authentication page.
  }

  const bIsDesktop = Utils.IsDesktop();

  return (
    <>
      <div className={classnames("auth-bg", { "auth-bg-light": props.lightBg })}>
        <Container fluid className="p-0">
          <Row className=" g-0">
            <Col xl={3} lg={4}>
              <div className="p-4 pb-0 p-md-5 pb-md-0 auth-logo-section">
                <div className={props.lightBg ? "auth-accent-text" : "text-white-50"}>
                  <h3>
                    <Link to="/" className={props.lightBg ? "auth-accent-text" : "text-white"}>
                      <i className={classnames("bx bxs-message-alt-detail align-middle h3 mb-1 me-2", props.lightBg ? "auth-accent-text" : "text-white")}></i>{" "}
                      {process.env.REACT_APP_NAME}
                    </Link>
                  </h3>
                  <p className="font-size-16">
                    ทำให้การติดต่อ เป็นเรื่องง่าย
                  </p>
                </div>
                {SHOW_AUTH_IMG && (
                  <div className="mt-auto">
                    <img src={authImage} alt="auth" className="auth-img" />
                  </div>
                )}
              </div>
            </Col>

            <Col xl={9} lg={8}>
              <div className="authentication-page-content">
                <div className="d-flex flex-column h-100 px-4 pt-4">
                  {props.children}

                  <Row className="">
                    <Col xl={12}>
                      {/* <div className="text-center text-muted p-4"> */}
                      <div className="text-center text-muted pt-2 pb-2 no-wrap">
                        <p className="mb-0 no-wrap">
                          &copy; {new Date().getFullYear()} Chat Platform {" "}
                          <i className="mdi mdi-heart text-danger"></i> by 2S Metal
                          <br />
                          <a href="/policy">PDPA</a>
                          {bIsDesktop && <>
                            &nbsp;| &nbsp;
                            <a href={getLineLoginUrl()}>
                              <img height="16" src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/41/LINE_logo.svg/320px-LINE_logo.svg.png?20220419085336"></img>
                              <span style={{ fontSize: "12px", color: "green", paddingLeft: "2px" }}>พนักงาน</span>
                            </a>
                          </>}
                        </p>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default NonAuthLayoutWrapper;
